import { useSelector } from 'react-redux';

//CSS
import './sucursales.css';

//MUI
import { Container, Typography, Skeleton, Stack, useMediaQuery } from '@mui/material';

//Components
import CardSucursal from './CardSucursal';
import BranchesMap from './BranchesMap';

const SucursalesComponent = () => {
    const matches = useMediaQuery('(max-width: 950px)');
    const { branches, fetched } = useSelector(state => state.shop);

    if (!fetched)
        return (
            <Container maxWidth="xl" spacing={2} sx={{ mt: matches ? 5 : 18, mb: 5 }}>
                <Skeleton variant="rounded" height={500} />
                <Skeleton  variant="text" sx={{ mt: 5, fontSize: '2rem' }} />
                <Stack direction="row" spacing={2} sx={{ mt: 5 }}>
                    <Skeleton variant="rounded" height={120} sx={{ flex: 1 }} />
                    <Skeleton variant="rounded" height={120} sx={{ flex: 1 }} />
                    <Skeleton variant="rounded" height={120} sx={{ flex: 1 }} />
                </Stack>
            </Container>
        );
    
    return (
        <>
            <Container maxWidth="xl" sx={{ mt: matches ? 5 : 18 }} className="map">
                <BranchesMap height={500} />
            </Container>

            <Container maxWidth="xl" sx={{ mt: 5 }}>
                <Typography variant="h5" align='center'>
                    Contamos con <b>{branches.length}</b> sucursales.
                </Typography>
            </Container>

            <Container maxWidth="xl" sx={{ mt: 5 }} className="last-view">
                <CardSucursal branches={branches} />
            </Container>
        </>
    );
};

export default SucursalesComponent;
